import * as React from 'react';
import * as _ from 'lodash';
import { BaseInput, BaseProps } from './_BaseInput';
import ContinueButton from '../components/ContinueButton';
import { getStringFromMultimediaTexts } from '@nexxt/common/services/TextService';
import {
    UilExpandArrowsAlt,
    UilCompressArrows
} from '@iconscout/react-unicons';
import { Question } from '@nexxt/common/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMicrophone,
    faPlay,
    faVideo
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { BASE_THEME } from '../style/BotThemes';
import { request } from 'http';

interface Props extends BaseProps {
    question: Question;
    onAck: () => void;
    confirm: boolean;
    langId: string;
}

const PermissionWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .permission-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        cursor: pointer;
        background: rgba(249, 232, 249, 1);
        color: ${BASE_THEME.pink};
        border-radius: 50%;
        gap: 8px;

        svg {
            font-size: 1.8em;
            path {
                fill: ${BASE_THEME.pink};
                transition: all 0.2s ease-in;
                -webkit-transition: all 0.2s ease-in;
                -moz-transition: all 0.2s ease-in;
            }
        }

        &.--granted {
            background: #e1e1e1;
            color: ${BASE_THEME.green};

            svg {
                path {
                    fill: ${BASE_THEME.green};
                }
            }
        }
        &.disabled {
            background: rgba(0, 0, 0, 0.2);
            color: #4a4a4a;
            cursor: not-allowed;

            svg {
                path {
                    fill: #4a4a4a;
                }
            }
        }
    }
`;

export const PermissionPrompt = (props: Props) => {
    const [hasPermission, setHasPermission] = React.useState(false);
    const getPermission = async (permission) => {
        try {
            const result = await navigator.permissions.query({
                name: permission
            });
            if (result.state == 'granted') {
                setHasPermission(true);
            }
            console.log(result.state);
        } catch (error) {
            console.log(error);
        }
    };
    React.useEffect(() => {
        if (!props.question.showContinueButton) {
            props.onAck();
        }
        getPermission('microphone');
    }, [hasPermission]);

    const requestPermission = async (e, request) => {
        e.preventDefault();
        try {
            const userMedia = await navigator.mediaDevices.getUserMedia(
                request
            );
            if (userMedia) {
                console.log(userMedia);
                setHasPermission(true);
            }
        } catch (error) {}
    };

    const { langId, onAck, question } = props;
    const { continueTexts } = question;
    const continueText = getStringFromMultimediaTexts(continueTexts, langId);

    const handlePlay = () => {
        console.log('play sound');
    };
    return (
        <React.Fragment>
            {question.multimediaSettings?.showMicPermissionPrompt && (
                <PermissionWrapper>
                    <div className="permission-wrap">
                        <div
                            className={`icons permission-icon ${
                                hasPermission ? '--granted' : ''
                            }`}
                            onClick={(e) =>
                                requestPermission(e, { audio: true })
                            }
                        >
                            <FontAwesomeIcon icon={faMicrophone} />
                        </div>
                    </div>
                    <div>
                        {hasPermission
                            ? `Permission has been granted. You may now Continue.`
                            : `You may click the icon above to request permission.`}
                    </div>
                </PermissionWrapper>
            )}
            {question.multimediaSettings?.showCameraPermissionPrompt && (
                <PermissionWrapper>
                    <div className="permission-wrap">
                        <div
                            className={`icons permission-icon ${
                                hasPermission ? '--granted' : ''
                            }`}
                            onClick={(e) =>
                                requestPermission(e, { video: true })
                            }
                        >
                            <FontAwesomeIcon icon={faMicrophone} />
                        </div>
                    </div>
                    <div>
                        {hasPermission
                            ? `Permission has been granted. You may now Continue.`
                            : `You may click the icon above to request permission.`}
                    </div>
                </PermissionWrapper>
            )}
            {question.multimediaSettings?.showVideoPermissionPrompt && (
                <PermissionWrapper>
                    <div className="permission-wrap">
                        <div
                            className={`icons permission-icon ${
                                hasPermission ? '--granted' : ''
                            }`}
                            onClick={(e) =>
                                requestPermission(e, {
                                    audio: true,
                                    video: true
                                })
                            }
                        >
                            <FontAwesomeIcon icon={faVideo} />
                        </div>
                    </div>
                    <div>
                        {hasPermission
                            ? `Permission has been granted. You may now Continue.`
                            : `You may click the icon above to request permission.`}
                    </div>
                </PermissionWrapper>
            )}
            {question.multimediaSettings?.showSoundCheckPrompt && (
                <PermissionWrapper>
                    <div className="permission-wrap">
                        <div
                            className="icons permission-icon"
                            onClick={handlePlay}
                        >
                            <FontAwesomeIcon icon={faPlay} />
                        </div>
                    </div>
                </PermissionWrapper>
            )}

            {question.showContinueButton && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '20px 0'
                    }}
                >
                    <ContinueButton
                        disabled={false}
                        onClick={onAck}
                        text={continueText}
                    />
                </div>
            )}
        </React.Fragment>
    );
};
